import { ADD_NEW_PING_POINT, ADD_NEW_PING_POINT_ERROR } from "../types";

const initialState = {
  homeInfo: {},
  loading: true,
};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  switch (action.type) {
    case ADD_NEW_PING_POINT:
      return {
        ...state,
        homeInfo: action.payload,
        loading: false,
      };
    case ADD_NEW_PING_POINT_ERROR:
      return {
        ...state,
        loading: true,
      };

    default:
      return state;
  }
}
